import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import { UserListHead, UserListToolbar } from "../../components/_dashboard/user";
// import USERLIST from '../_mocks_/user';

import axios from "axios";
import { BASE_URL } from "src/config/constants";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import ImagePicker from "src/components/common/ImagePicker";
import MyPagination from "src/components/common/MyPagination";
import ListHead from "src/components/common/ListHead";
const TABLE_HEAD = [
  { id: "name", label: "名称", alignRight: false },
  // { id: "icon", label: "图标", alignRight: false },
  { id: "order", label: "排序", alignRight: false },
  { id: "visible", label: "是否显示", alignRight: false },
  // { id: "createdAt", label: "添加时间", alignRight: false },
  { id: "" },
];

const moreMenus = [
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

export default function ArticleCategory() {
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const [action, setAction] = useState("");
  const [targetCategory, setTargetCategory] = useState({});
  const [form, setForm] = useState({
    name: "",
    icon: "",
    isShow: 1,
    order: 0,
  });

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    axios
      .get("/article/category/all")
      .then((res) => {
        const { code, msg, data, count } = res.data;
        if (code === 1) {
          setItems(data);
          setTotal(count);
        } else {
          alert(msg);
        }
      })
      .catch((err) => { });
  }, []);

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleAddBanner() {
    setAction("add");
    setForm({
      name: "",
      icon: "",
      isShow: 1,
      order: 0,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`edit/${row.id}`);
      setTargetCategory({ ...row });
      setAction("edit");
      setForm({
        name: row.name,
        icon: row.icon,
        isShow: row.isShow,
        order: row.order,
      });
    } else if (type === "删除") {
      handleDelBanner(row.id);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/article/category/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除商学院分类失败: ", err);
          });
      },
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDialogConfirm() {
    if (!form.name) return alert("商学院分类名称不能为空");

    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetCategory.id;
    }

    axios
      .post(action === "add" ? "/article/category/add" : "/article/category/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const category = items.find((b) => b.id === targetCategory.id);
            category.name = formData.name;
            category.icon = formData.icon;
            category.order = parseInt(formData.order);
            category.isShow = parseInt(formData.isShow);
            items.sort((c1, c2) => c2.order - c1.order);
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改商学院分类失败: ", err);
      });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="商学院分类列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商学院分类列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddBanner}>
            添加商学院分类
          </Button>
        </Stack>

        <Card>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />

                <TableBody>
                  {items.map((row) => {
                    const { id, name, icon, path, isShow, order, createdAt } = row;
                    const isItemSelected = selected.indexOf(icon) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{name}</TableCell>
                        {/* <TableCell align="left">
                          <img src={`${BASE_URL}${icon}`} style={{ maxWidth: 60 }} />
                        </TableCell> */}
                        <TableCell align="left">{order}</TableCell>
                        <TableCell align="left">
                          <Switch checked={!!isShow} />
                        </TableCell>

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>


      </Container>

      <FormDialog title={action === "add" ? "添加分类" : "修改分类"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="分类名称" required>
          <TextField fullWidth placeholder="请输入分类名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        <FormItem title="分类排序" required>
          <TextField fullWidth placeholder="分类排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
        </FormItem>

        <FormItem title="分类状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
            <FormControlLabel value={0} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          </RadioGroup>
        </FormItem>
      </FormDialog>
    </Page>
  );
}
